import { Component } from '@angular/core';
import { Router, RouterEvent, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { async } from '@angular/core/testing';
import { TSFuntionService } from './services/ts-funtion.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  public showOverlay = true;

  constructor(
    private router: Router,
    private System: TSFuntionService,
  ) {
   
    router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event)
    })
  }

  // Shows and hides the loading spinner during RouterEvent changes
  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      //this.showOverlay = true;
      this.System.BlockUI();
    }
    if (event instanceof NavigationEnd) {
      this.System.UnBlockUI();
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.System.UnBlockUI();
    }
    if (event instanceof NavigationError) {
      this.System.UnBlockUI();
    }
  }
}
